module.exports = __webpack_public_path__ + "img/vinu.a8178943.jpeg";